/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const RemoveVocalIcon = createIcon(
  '0 0 20 20',
  <path d="M18.707 14.707 17.414 16l1.293 1.293-1.414 1.414L16 17.414l-1.293 1.293-1.414-1.414L14.586 16l-1.293-1.293 1.414-1.414L16 14.586l1.293-1.293zm-6.448-2.024A4.98 4.98 0 0 0 11 16c0 .711.15 1.387.417 2H8.5l-1-7h5zM10 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8" />,
);
